import { lazy, Suspense } from "react";
import { useParams, Navigate } from "react-router-dom";

const pages = {
  "osteria-fortuna": lazy(() => import("./demos/Restaurant")),
  "halbritter-architekten": lazy(() => import("./demos/Architektur")),
  "brenner-sohn": lazy(() => import("./demos/Handwerk")),
  "maison-lumiere": lazy(() => import("./demos/Beauty")),
  "kraftwerk-studio": lazy(() => import("./demos/Fitness")),
  "aurum-automobile": lazy(() => import("./demos/Automobile")),
};

export default function DemoSite() {
  const { slug } = useParams();
  const Page = pages[slug];
  if (!Page) return <Navigate to="/" replace />;
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-[#050505]">
          <span className="gold-text animate-pulse font-serif-accent text-3xl">S&F</span>
        </div>
      }
    >
      <Page />
    </Suspense>
  );
}
